import React, { useContext, useEffect, useState } from 'react';
import { useActor } from '@xstate/react';
import classNames from 'classnames';
import { GlobalStateContext } from '../../state/app/index';
import MainNavigation from '../navigation/MainNavigation';
import NavItem from '../navigation/NavItem';
import NavLink from '../navigation/NavLink';
import NavDropdown from '../navigation/NavDropdown';
import {
  CreateAreaOfFocusModal,
  CreateNotebookModal,
} from '../../utils/newEntityHelper';
// import KeyboardShortcuts from './KeyboardShortcuts';
import { deleteDatabases } from '../../state/offline';
import UserLogs from './UserLogs';
import { isMobile } from '../../utils/helpers.ts';
// import { createNoteDocument } from '../../utils/helpers';

/*
 * @todo Prevent having to prop-drill these values
 * selectedNote={selectedNote}
 * trashSelectedNote={trashSelectedNote}
 * breakpoint={currentBreakpoint}
 */
const Header = (props) => {
  const globalServices = useContext(GlobalStateContext);
  const [appState, sendAppState] = useActor(globalServices.appState);
  const [modalState, sendModalState] = useActor(globalServices.modalState);
  const [activeTab, setActiveTab] = useState('notes');

  const {
    context: { notes, newNoteEntityObject, breakpoint },
  } = appState;

  const selectTab = (tabName) => {
    setActiveTab(tabName);
    sendAppState({ type: 'SelectTab', tabName });
  };

  // Set up dry.ledger() function to open User Logs modal
  useEffect(() => {
    if (typeof window !== 'undefined' && window.DRY) {
      window.DRY._openUserLogs = () => {
        sendModalState({
          type: 'updateModal',
          data: {
            title: 'User Logs',
            sectionClassName: 'user-logs-modal',
            showCloseModal: true,
            content: <UserLogs />,
            primaryButton: {
              show: false,
            },
            secondaryButton: {
              show: false,
            },
          },
        });
      };
    }
  }, [sendModalState]);

  const renderNoteContent = (snippetNoteID) => {
    const selectedNote = notes[snippetNoteID];

    return (
      <div className="delete-note-modal-body">
        <h2 className="note-title">{selectedNote.note_title}</h2>
      </div>
    );
  };

  // const showDeleteModal = (selectedNote) => {
  //   const {
  //     updateModal,
  //     trashSelectedNote,
  //     closeModal,
  //   } = props;

  //   if (selectedNote) {
  //     updateModal({
  //       visible: true,
  //       title: 'Are you sure you want to move your note to the trash?',
  //       sectionClassName: 'delate-note-modal',
  //       showCloseModal: false,
  //       content: renderNoteContent(selectedNote),
  //       primaryButton: {
  //         title: 'Trash',
  //         callback: function() {
  //           trashSelectedNote(selectedNote);
  //           closeModal();
  //         },
  //       },
  //       secondaryButton: {
  //         title: 'Don\'t Trash',
  //         callback: () => {
  //           props.closeModal();
  //         },
  //       },
  //     });
  //   }
  // }

  const renderAboutUsContent = () => {
    const versionContent = typeof window !== 'undefined' ? window.VERSION : '';
    return <div className="about-us-modal-body">{versionContent}</div>;
  };

  // const showAboutUsModal = () => {
  //   const {
  //     updateModal
  //   } = props;

  //   updateModal({
  //     visible: true,
  //     title: 'About Drynotes',
  //     sectionClassName: 'about-us-modal',
  //     showCloseModal: true,
  //     hidePrimaryButton: true,
  //     hideSecondaryButton: true,
  //     content: renderAboutUsContent(),
  //   });
  // }

  // const showKeyboardShortcutsModal = () => {
  //   props.updateModal({
  //     visible: true,
  //     title: 'Keyboard Shortcuts',
  //     sectionClassName: 'keyboard-shortcuts-modal',
  //     showCloseModal: true,
  //     hidePrimaryButton: true,
  //     hideSecondaryButton: true,
  //     content: KeyboardShortcuts(),
  //   });
  // }

  const deleteLocalDB = () => {
    const asyncClear = async () => {
      await deleteDatabases();
      location.reload();
    };

    asyncClear();
  };

  if (isMobile(breakpoint)) {
    return null;
  }

  // switch (breakpoint) {
  //   case 'desktop':
  //   case 'desktopLarge':
  //   case 'desktopWide':
  return (
    <header className="toolbar-header">
      <MainNavigation>
        {/* <NavDropdown label='Drynotes'>
              <NavLink link='/settings' title='Settings'>Settings</NavLink>
            </NavDropdown> */}
        <NavDropdown label="File" navClass="file">
          <NavDropdown label="New" navClass="new">
            <NavItem
              onSelect={() => {
                sendAppState({
                  type: 'createNote',
                  data: {
                    noteObject: newNoteEntityObject,
                    isSelectedAreaOfFocus: true,
                  },
                });
              }}
            >
              Note
            </NavItem>
            <NavItem
              onSelect={() => {
                sendAppState({
                  type: 'createNotebook',
                  data: {
                    notebookName: 'New Notebook',
                  },
                });
              }}
            >
              Notebook
            </NavItem>
            <NavItem
              onSelect={() => {
                // TODO: Implement Area of Focus creation
                // For now, just log that it's not implemented
                console.log('Create Area of Focus - Not implemented yet');
              }}
            >
              Area of Focus
            </NavItem>
          </NavDropdown>
          <NavLink link="/settings" title="Settings">
            Settings
          </NavLink>
          <NavLink
            link="/quicknote"
            title="Quick Note"
            target="_blank"
            isExternal
          >
            Quick Note
          </NavLink>
          {/* <NavItem onSelect={event => {
                event.stopPropagation();
                showDeleteModal(selectedNote);
                }}>Trash</NavItem> */}
          <NavItem
            onSelect={(event) => {
              location.reload();
            }}
          >
            Reload
          </NavItem>
        </NavDropdown>
        <NavDropdown label="View" navClass="view">
          <NavItem
            onSelect={() => {
              sendAppState({
                type: 'toggleCommandPalette',
              });
            }}
          >
            Command Palette
          </NavItem>
        </NavDropdown>
      </MainNavigation>
    </header>
  );
  //   case 'tablet':
  //   case 'tabletLandscape':
  //   case 'mobile':
  //   case 'mobileLandscape':
  //   default:
  //     return null;
  // }
};

export default Header;
